import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=3632cdba&style=height%3A%20100%25%3B"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=3632cdba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports